import React, { useState, useEffect } from 'react';

const ProgressModal = ({ isOpen, onClose, title, steps, currentStep, progress, message }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div className="text-center">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">{title}</h3>
          
          {/* Progress Bar */}
          <div className="w-full bg-gray-200 rounded-full h-3 mb-4">
            <div 
              className="bg-blue-600 h-3 rounded-full transition-all duration-300"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          
          {/* Progress Percentage */}
          <div className="text-sm text-gray-600 mb-4">
            {progress.toFixed(1)}% Complete
          </div>
          
          {/* Current Step */}
          {steps && (
            <div className="mb-4">
              <div className="text-sm font-medium text-gray-700 mb-2">
                Step {currentStep} of {steps.length}
              </div>
              <div className="space-y-2">
                {steps.map((step, index) => (
                  <div 
                    key={index}
                    className={`flex items-center text-sm ${
                      index < currentStep ? 'text-green-600' :
                      index === currentStep ? 'text-blue-600' :
                      'text-gray-400'
                    }`}
                  >
                    <div className={`w-4 h-4 rounded-full mr-3 flex items-center justify-center ${
                      index < currentStep ? 'bg-green-600' :
                      index === currentStep ? 'bg-blue-600' :
                      'bg-gray-300'
                    }`}>
                      {index < currentStep ? (
                        <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                      ) : (
                        <div className="w-2 h-2 bg-white rounded-full"></div>
                      )}
                    </div>
                    {step}
                  </div>
                ))}
              </div>
            </div>
          )}
          
          {/* Current Message */}
          {message && (
            <div className="text-sm text-gray-600 mb-4 min-h-[20px]">
              {message}
            </div>
          )}
          
          {/* Close Button (only show when progress is 100%) */}
          {progress >= 100 && (
            <button
              onClick={onClose}
              className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors"
            >
              Close
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProgressModal;
